module.exports = __webpack_public_path__ + "img/mind_background_10_th.b64f358b.png";